import React, { FunctionComponent } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { assetTypes } from "../../api/Definitions"
import FormInput from "../../components/Form/Inputs/FormInput"
import { FormSelectInput } from "../../components/Form/Select/Select"
import { iAssetQuery } from "../../definitions/Assets"
import { iChangeType } from "../../definitions/interfaces"

interface iProps {
  setQuery: (data: iAssetQuery, resetQuery?: boolean) => void
  query: iAssetQuery
}

const AssetFilters: FunctionComponent<iProps> = ({ setQuery }) => {
  const onChange = ({ name, value }: iChangeType) => {
    console.log(name, value)

    setQuery({ [name]: value })
  }

  const methods = useForm()

  return (
    <div className={`filters`}>
      <div className="filters-form">
        <FormProvider {...methods}>
          <FormInput
            placeholder="Search by title"
            autoComplete="off"
            name="title"
            onChange={onChange}
          />
          <FormSelectInput
            name={"type"}
            onChange={(value) => onChange({ name: "type", value })}
            isClearable={true}
            options={assetTypes}
          />
          <FormInput
            autoComplete="off"
            name="public"
            type="checkbox"
            label="Show Public"
            onChange={onChange}
          />
        </FormProvider>
      </div>
    </div>
  )
}

export default AssetFilters
